module.exports = __webpack_public_path__ + "media/bootstrap-icons/collection-fill-dc150446.svg";